/* eslint-disable max-len */
import styled, { createGlobalStyle } from "styled-components"

export const Primary = styled.main`
  flex: 1;

  background: var(--cloudGrey);
`

export const GlobalStyles = createGlobalStyle`

  
  :root {
    --illiniOrange:#ff552e;
    --illiniDarkBlue:#13294b;
    --backgroundGrey:#E5E5E5;
    --darkGrey:#f2f2f2;
    --cloudGrey:#f8f8f8;
    --lightGrey:#d6d6d6;
    --middleGrey:#e4e4e4;
    --darkestGrey:#6d6d6d;
    --white:#FFF;
    
}

@font-face {
  font-family: Monsterrat;
  src: url("/fonts/Montserrat/Montserrat-Bold.ttf")format('truetype');
}

@font-face {
  font-family: Monsterrat Bold;
  src:url("/fonts/montserrat/Montserrat-Bold.ttf")format('truetype');
}

@font-face {
  font-family: Fjalla_One;
  src:url("/fonts/Fjalla_One/FjallaOne-Regular.ttf")format('truetype');
}

@font-face {
  font-family: Source Sans Pro;
  src:url("/fonts/Source_Sans_Pro/SourceSansPro-Regular.ttf")format('truetype');
}

@font-face {
  font-family: Source Serif Pro;
  src:url("/fonts/Source_Serif_Pro/SourceSerifPro-Regular.ttf")format('truetype');
}

  html {
    font-family: 'Source Sans Pro';
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .whiteText {
    color: #fff;
  }

  h2,
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
  }
  audio:not([controls]) {
    display: none;
    height: 0;
  }
  progress {
    vertical-align: baseline;
  }
  [hidden],
  template {
    display: none;
  }
  a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }
  a:active,
  a:hover {
    outline-width: 0;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: inherit;
    font-weight: bolder;
  }
  dfn {
    font-style: italic;
  }
  h1 {
    font-family:'Monsterrat';
    font-weight: 700;
    font-size: 2em;
    margin: 0.67em 0;
  }
  mark {
    background-color: #ff0;
    color: #000;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  figure {
    margin: 1em 40px;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font: inherit;
    margin: 0;
  }
  optgroup {
    font-weight: 700;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  [type='reset'],
  [type='submit'],
  button,
  html [type='button'] {
    -webkit-appearance: button;
  }
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner,
  button::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring,
  button:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }
  textarea {
    overflow: auto;
  }
  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type='search']::-webkit-search-cancel-button,
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-input-placeholder {
    color: inherit;
    opacity: 0.54;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  html {
    font: 112.5%/1.45em arial, georgia, serif;
    box-sizing: border-box;
    overflow-y: scroll;
  }
  * {
    box-sizing: inherit;
  }
  *:before {
    box-sizing: inherit;
  }
  *:after {
    box-sizing: inherit;
  }
  body {
    color: hsla(0, 0%, 0%, 0.8);
    font-family: 'arial', georgia, serif;
    font-weight: normal;
    word-wrap: break-word;
    font-kerning: normal;
    -moz-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
    -ms-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
    -webkit-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
    font-feature-settings: 'kern', 'liga', 'clig', 'calt';
  }
  img {
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  p {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1.1rem;
    line-height: 1.7rem;
  }

  h1 {
    font-size: 2.2rem;
    font-family: 'Teko', Arial;
    font-weight: 800;
    letter-spacing: 1px;
    color: #282828;
    line-height: 40px;
    margin-top: 10px;
  }

  h2 {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color:var(--illiniDarkBlue);
    margin-top:0;
    width: 100%;

  }
  h3 {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
    color: inherit;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    font-weight: bold;
    text-rendering: optimizeLegibility;
    font-size: 1.38316rem;
    line-height: 1.1;

    width: 100%;

  }
  h4 {
    font-family: Arial;
    font-weight: 800;
    font-size: 1.2rem;
    letter-spacing: 1px;
  }
  h5 {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-variant: normal;
    font-weight: 200;
    letter-spacing: 1px;
    margin-bottom: 10px;
    color: #000;
    text-transform: uppercase;
  }
  h6 {
    font-family: 'Times New Roman';
    font-size: 28px;
    color: #fff;
    font-style: italic;
    margin: 40px 20% 20px 20%;
    line-height: 35px;
  }
  hgroup {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  ul {
    margin-left: 1.45rem;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
    list-style-position: outside;
    list-style-image: none;

    width: 100%;

  }
  ol {
    margin-left: 1.45rem;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
    list-style-position: outside;
    list-style-image: none;
  }
  dl {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  dd {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  p {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  figure {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  pre {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 1.45rem;
    font-size: 0.85rem;
    line-height: 1.42;
    background: hsla(0, 0%, 0%, 0.04);
    border-radius: 3px;
    overflow: auto;
    word-wrap: normal;
    padding: 1.45rem;
  }
  table {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
    font-size: 1rem;
    line-height: 1.45rem;
    border-collapse: collapse;
    width: 100%;
  }
  fieldset {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  blockquote {
    margin-left: 1.45rem;
    margin-right: 1.45rem;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  form {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  noscript {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  iframe {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  hr {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: calc(1.45rem - 1px);
    background: hsla(0, 0%, 0%, 0.2);
    border: none;
    height: 1px;
  }
  address {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  b {
    font-weight: bold;
  }
  strong {
    font-weight: bold;
  }
  dt {
    font-weight: bold;
  }
  th {
    font-weight: bold;
  }
  li {
    margin-bottom: 0;
  }
  ol li {
    padding-left: 0;
  }
  ul li {
    padding-left: 0;
  }
  li > ol {
    margin-left: 1.45rem;
    margin-top: calc(1.45rem / 2);
  }
  li > ul {
    margin-left: 1.45rem;
    margin-top: calc(1.45rem / 2);
  }
  blockquote *:last-child {
    margin-bottom: 0;
  }
  li *:last-child {
    margin-bottom: 0;
  }
  p *:last-child {
    margin-bottom: 0;
  }
  li > p {
    margin-bottom: calc(1.45rem / 2);
  }
  code {
    font-size: 0.85rem;
    line-height: 1.45rem;
  }
  kbd {
    font-size: 0.85rem;
    line-height: 1.45rem;
  }
  samp {
    font-size: 0.85rem;
    line-height: 1.45rem;
  }
  abbr {
    border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
    cursor: help;
  }
  acronym {
    border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
    cursor: help;
  }
  abbr[title] {
    border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
    cursor: help;
    text-decoration: none;
  }
  thead {
    text-align: left;
  }
  td,
  th {
    text-align: left;
    border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);
    font-feature-settings: 'tnum';
    -moz-font-feature-settings: 'tnum';
    -ms-font-feature-settings: 'tnum';
    -webkit-font-feature-settings: 'tnum';
    padding-left: 0.96667rem;
    padding-right: 0.96667rem;
    padding-top: 0.725rem;
    padding-bottom: calc(0.725rem - 1px);
  }
  th:first-child,
  td:first-child {
    padding-left: 0;
  }
  th:last-child,
  td:last-child {
    padding-right: 0;
  }
  tt,
  code {
    background-color: hsla(0, 0%, 0%, 0.04);
    border-radius: 3px;
    font-family: 'SFMono-Regular', Consolas, 'Roboto Mono', 'Droid Sans Mono',
      'Liberation Mono', Menlo, Courier, monospace;
    padding: 0;
    padding-top: 0.2em;
    padding-bottom: 0.2em;
  }
  pre code {
    background: none;
    line-height: 1.42;
  }
  code:before,
  code:after,
  tt:before,
  tt:after {
    letter-spacing: -0.2em;
    content: ' ';
  }
  pre code:before,
  pre code:after,
  pre tt:before,
  pre tt:after {
    content: '';
  }
  .primaryTitle{
    font-family:'Monsterrat';
    font-weight:800;
    font-size:3rem;
    line-height: 3rem;
    width:100%;
    color:var(--illiniDarkBlue);
  }
  .secondaryTitle{
    font-family:'Monsterrat';
    font-weight:800;
    font-size:2.5rem;
    color:var(--illiniDarkBlue);
    line-height: 2.5rem;
  }
  .tertiaryTitle{
    font-family:'Source Sans Pro';
    font-weight:600;
    font-size:2rem;
    color:var(--illiniDarkBlue);
  }
  .headline{
    font-family:'Source Sans Pro';
    font-weight:700;
    font-size: 1.5rem;
    color:var(--illiniDarkBlue);
    font-style:normal;
  }
  .paragraphLarge{
    font-family:'Source Sans Pro';
    font-weight:400;
    font-size:1rem;
    color:var(--darkestGrey);
  }
  .paragraphSmall{
    font-family:'Source Sans Pro';
    font-weight:400;
    font-size:1rem;
    color:var(--darkestGrey);
  }

  .paragraph{
    font-family:'Source Sans Pro';
    font-weight:400;
    font-size:1rem;
    color:var(--darkestGrey);
  }

  .paragraph100Width{
      font-family:'Source Sans Pro';
    font-weight:400;
    font-size:1rem;
    color:var(--darkestGrey);
    width:100%;

  }
  .paragraphSmallBlue{
    font-family:'Source Sans Pro';
    font-weight:400;
    font-size:1rem;
    color:var(--illiniDarkBlue);
  }
  .primaryLabel {
    font-family:'Monsterrat';
    font-weight:800;
    font-size:1rem;
    letter-spacing:1.5px;
    text-transform:uppercase;
    color:var(--illiniDarkBlue);
  }
  .secondaryLabel{
    font-family:'Monsterrat';
    font-weight:800;
    font-size: 1rem;
    letter-spacing:1.5px;
    text-transform:uppercase;
    color:var(--illiniOrange);
  }
  .detail{
    font-family: 'Source Sans Pro';
    font-weight: 400;
    font-size: 1rem;
    color:var(--darkestGrey);
  }
  .primaryLinkLarge{
    font-family: 'Source Sans Pro';
    font-weight: 700;
    font-size: 1.25rem;
    color:var(--illiniDarkBlue);
  }
 .primaryLink{
    font-family: 'Source Sans Pro';
    font-weight: 700;
    font-size: 1rem;
    
  }
  .secondaryLink{
    font-family: 'Source Sans Pro';
    font-weight: 600;
    font-size: 1rem;
    color:var(--illiniDarkBlue);  
  }
  .unitTitleLarge{
    font-family: 'Source Sans Pro';
    font-weight: 700;
    font-size: 1.5rem;
    color:var(--illiniDarkBlue);
  }
  .unitTitleSmall{
    font-family: 'Source Sans Pro';
    font-weight: 700;
    font-size: 1rem;
    color:var(--illiniDarkBlue);
  }

  .underline{
    text-decoration:underline;
  }

  .rightLink{
     

    margin-bottom: 0.5rem !important;
  
  }

  .serviceTop{
      flex-wrap: wrap;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: fit-content;
  }



  .rightLink a{
        text-decoration: none !important;
    font-family: "Source Sans Pro";
    font-weight: 700;
    font-size: 1.2rem;
    color: var(--illiniDarkBlue);
    font-style: normal !important;
  }
  .wp-block-video{
    max-width:100%;
  }

  video{
    max-width:100%;
  }
      iframe{
    width: 100%;
    min-height: 25rem;
    }

  .wp-block-code{
    display:none;
  }

  .rightTop{
    margin-top:6rem;
    max-width: 300px;
  }

  .pageImage{
    margin-bottom:1rem;
  }

  .wp-block-separator{
    width:100%;
    margin-top:1rem;
    margin-bottom:1rem;
  }

  .rowTeams {
    width: 100%;
    min-height: 500px;
    margin-bottom:1rem;
    display:flex;
    justify-content:space-round;
}
.col-sm-4 {
    width: 33.333%;
    float: left;
    position: relative;
    min-height: 1px;
}
.service-item {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    -webkit-flex-flow: column;
    -ms-flex-flow: column;
    flex-flow: column;
    height: 430px;
    width: 95%;
    margin: 0 auto;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 5px rgba(0,0,0,0.2);
    background: white;
}

.title-wrapper {
    padding: 3rem 2rem;
    text-align: center;
    text-align: center;
}

.title-wrapper .entry-title {
    margin: 0 0 .5rem;
    font-size: 1.5rem;
    position: relative;
    padding-bottom: .5rem;
}

.title-wrapper .entry-content {
    margin: .5rem 0 0;
}

.teamsInfoHide {
    display: none;
}

.wp-block-image img {
    width: 100%;
    height: auto;
    }

.teamsInfoShow {
    display: block;
    background: white;
    width: 100%;
    margin: 0 auto;
    box-shadow: 0 0 5px rgba(0,0,0,0.2);
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 30px;
}

.teamsInfoInner {
    width: 90%;
    margin: 0 auto;
}

  .optanon-alert-box-wrapper {
    background-color: rgba(0,0,0,0.8) !important;
}
.optanon-alert-box-wrapper .optanon-button-more .optanon-alert-box-button-middle a:before {
    content: none;
}
.optanon-alert-box-wrapper .optanon-button-allow .optanon-alert-box-button-middle a:before {
    content: none;
}
.optanon-alert-box-wrapper .optanon-alert-box-button-middle {
    background-color: #57802D !important;
}
.optanon-alert-box-body a {
    color: #FFF !important;
    text-decoration: underline !important;
    padding-left: 5px;
}
@media only screen and (max-width: 752px) {
    
    .optanon-alert-box-wrapper .optanon-alert-box-bg p {
        font-size: 9pt;
        line-height: 12pt;
    }
    .optanon-alert-box-bg .optanon-alert-box-button-container {
        text-align: right;
        margin-left: 1em;
    }
}
  .whitebg{
    background-color:var(--white);
  }
  .container h3{
    width: 100%;
  }
  
  .container h4{
    width: 100%;
  }
  .wp-block-ub-tabbed-content{
    max-width:100%;
    overflow-x:scroll;
  }


  .imgMargin{
    margin-bottom:0px;
    padding-right:.5rem;
  }

  .whiteTxt{
    color:var(--white);
  }

  .darkBlueTxt{
    color:var(--illiniDarkBlue);
  }

  .greyDarkestTxt{
    color:var(--darkestGrey);
  }

  .serviceTop{
    max-width:800px;
  }
  
  .container ul {
    list-style: none;
    color:var(--darkestGrey);
    font-family:'Source Sans Pro';
    font-weight:400;
    font-size:1rem;
    text-align: left;
  }

  .container li{
    margin-bottom:0;
  }

  .iconContainer{
        border-radius: 0.25rem;
  }
  
  .container li::before {
    content: "•";
    color: var(--illiniOrange);
    padding-right:1rem;
  }


  .serviceTop h2{
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px; 
  color:var(--illiniDarkBlue); 
  }

  .providerImage{

    margin-bottom:2rem;
    width:500px;
    height:auto;
    float:left;

  }

  .container{
    width: 100%;
    padding-top: 2rem;
    padding-bottom:2rem;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    max-width:1180px;
    margin:0 auto;
  }

  .newsImage{
    max-width:100%;
    height:auto;
    margin-bottom: 0;
  }


  .employeeLandingPageImage{
    min-width:100%;
    height:200px;
    margin-bottom: 0;
  }

   .wp-block-ub-tabbed-content-tab-title-vertical-wrap .active{
  background-color: var(--illiniDarkBlue);
  color: var(--white); 
  }



  .newsTop{
    width:100%;

  }

  .cardTop{
        padding: 1.5rem;
    width: 100%;
    padding-bottom: 0;
    display: flex;
  }

  .leftWrap{
    padding:1.5rem;
    padding-right:0;
    max-width:50%;
    display:flex;
    flex-wrap:wrap;
  }

  .container  a{
    text-decoration:underline;
    font-style:italic;
  }

  .container .btn {
  text-decoration: none;
    font-style: normal;
  }

  .newsBottom p{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: var(--darkestGrey);
  }

  .newsBottom h2{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color:var(--illiniDarkBlue);

  }

  .newsBottom h3{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: var(--illiniDarkBlue);
  }

  .newsBottom img{
    padding:1rem;
    height:auto;
    max-width:100%;
    float:right;
  }
  ol{
    list-style:none;
    color: var(--darkestGrey);
    width:100%;
  }

  .results{
    list-style:none;
  }

  .categoryIcon{
    width:2rem;
    margin-right:1rem;
    height:2rem;
    margin-bottom:0px;
    margin-top:0px;
  }

    .secondaryLabelMax{
    font-family:  'Source Sans Pro';
font-style: normal;
font-weight: 600;
font-size: 14px;
letter-spacing: 1.5px;
text-transform: uppercase;
    }

    .selected{
        background: var(--illiniDarkBlue);
        color:white;
    }

    .selected:hover{
        color:var(--illiniDarkBlue);
        border: 2px solid var(--illiniDarkBlue);
    }


  .wp-block-file__button{
    background: var(--illiniDarkBlue);
    color: var(--white);
    border-radius: 0.5rem;
    padding: 0.5rem;
    /* border: 1px solid var(--illiniOrange); */
    margin-left: 1rem;
    margin-right: 1rem;
        line-height: 3rem;

            text-decoration: none !important;
    font-style: normal !important;

  }

  .wp-block-file > a:first-of-type{
    text-decoration:underline;
    font-style:italic
  }


  .wp-block-gallery{
    display:flex;
    flex-wrap:wrap;
    justify-content:space-around;
}

.wp-block-gallery > figure{
    width:30%
}

  @media only screen and (max-width:992px){
    .col-sm-4 {
    width: 50%;
    float: left;
    position: relative;
    min-height: 1px;
}

      .rightTop{
    margin-top:0rem;
  }
        .leftWrap{
        max-width:100%;
        width:100%;
    }



      .pageImage{
    margin-bottom:1rem;
  }

.wp-block-gallery > figure{
    width:45%
}

    .container{
      padding:2rem;
          justify-content: space-around;

    }
      .wp-block-group__inner-container{
    width:80vw;
    max-width:80vw;
  }

  .serviceTop{
    text-align:center;
    word-wrap: revert;
    max-width: 100%;
        justify-content: center;
  }

  .wp-block-ub-content-toggle {

    width:50%;
}

.rowTeams img {
    margin-bottom:0 !important;
}


  }
  @media only screen and (max-width: 480px) {
    .col-sm-4 {
    width: 100%;
    float: left;
    position: relative;
    min-height: 1px;
}
    .leftWrap{
        max-width:100%;
        width:100%;
    }
    .wp-block-gallery > figure{
    width:100%
}

    .primaryTitle {

    font-size: 2.5rem;
    line-height: 2.5rem;

}
    html {
      font-size: 100%;
    }

    .wp-block-ub-content-toggle {

    width:100%;
}
      .wp-block-group__inner-container{
    width:80vw;
    max-width:80vw;
  }

    .container{

      width:100%;
      padding:1rem;

    }

      .serviceTop{
    text-align:center;
    word-wrap: revert;
    max-width: 100%;
        justify-content: center;
  }

    .contactCardHolder{
        width:300px;
        margin:0 auto;
        display:block;
    }
  }


.nope {
    color: rgba(0, 0, 0, 0)
}

.ub-advanced-video-container {
    width: fit-content;
    max-width: 100%
}

.ub-advanced-video-thumbnail {
    position: relative
}

.ub-advanced-video-thumbnail>svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}

.ub-advanced-video-embed.ub-advanced-video-autofit-youtube {
    width: 100%
}

.ub-advanced-video-embed.ub-advanced-video-autofit-youtube>iframe {
    width: 100%
}

.ub-advanced-video-embed.ub-advanced-video-autofit-vimeo,
.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion {
    position: relative
}

.ub-advanced-video-embed.ub-advanced-video-autofit-vimeo>iframe,
.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion>iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
}

.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion {
    height: 0;
    overflow: hidden
}

.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion>iframe {
    overflow: hidden
}

.wp-block-ub-button-block {
    margin: 30px auto;
    max-width: 100%
}

.ub-button-container {
    max-width: 100%;
    display: flex;
    padding: 10px 0;
    margin: 20px 0
}

.ub-button-container a.ub-button-block-main.ub-button-block-main,
.ub-button-container a.ub-button-block-btn.ub-button-block-btn {
    text-decoration: none
}

.ub-button-full-container {
    width: 100%
}

.ub-button-block-main {
    display: flex;
    cursor: pointer;
    transition: background-color .5s, color .5s, border .5s
}

.align-button-center {
    justify-content: center
}

.align-button-left {
    justify-content: flex-start
}

.align-button-right {
    justify-content: flex-end
}

.ub-button-small {
    width: 180px;
    padding: 10px;
    font-size: 13px !important
}

.ub-button-medium {
    width: 275px;
    padding: 15px;
    font-size: 17px !important
}

.ub-button-large {
    width: 417px;
    padding: 20px;
    font-size: 22px !important
}

.ub-button-larger {
    width: 512px;
    padding: 20px;
    font-size: 25px !important
}

.ub-button-flex-small {
    width: fit-content;
    width: -moz-fit-content
}

.ub-button-flex-medium {
    width: fit-content;
    width: -moz-fit-content
}

.ub-button-flex-large {
    width: fit-content;
    width: -moz-fit-content
}

.ub-button-flex-larger {
    width: fit-content;
    width: -moz-fit-content
}

.ub-button-block-btn {
    text-align: center;
    color: inherit;
    margin: 0 10px;
    display: flex;
    align-items: center
}

.ub-button-content-holder {
    display: flex;
    margin: 0 auto
}

.ub-button-icon-holder {
    display: flex;
    align-items: center;
    padding: 0 2px
}

.ub-button-full-width {
    width: 100%
}

.ub-buttons {
    margin: 20px 0
}

.ub-buttons.align-button-center {
    text-align: center
}

.ub-buttons.align-button-left {
    text-align: left
}

.ub-buttons.align-button-right {
    text-align: right
}

.ub-buttons>.ub-button-container {
    display: inline-block;
    margin: 0 10px
}

@media(max-width: 599px) {
    .ub-button-flex-small {
        min-width: 70%
    }
    .ub-button-flex-medium {
        min-width: 80%
    }
    .ub-button-flex-large {
        min-width: 90%
    }
    .ub-button-flex-larger {
        min-width: 100%
    }
}

.wp-block-ub-block-call-to-action {
    margin: 0 auto;
    max-width: 100%
}

.ub_call_to_action {
    box-sizing: border-box;
    width: 100%;
    padding: 0 60px;
    margin: 30px 0 60px 0;
    border-style: solid;
    border-radius: 3px
}

.ub_call_to_action .ub_call_to_action_button {
    display: flex;
    align-items: center
}

.ub_call_to_action .ub_call_to_action_button .ub_cta_button a,
.ub_call_to_action .ub_call_to_action_button a.ub_cta_button {
    text-decoration: none
}

.ub_call_to_action_headline {
    width: 100%;
    padding: 20px 20px 10px 20px
}

.ub_call_to_action_headline p,
.ub_call_to_action_headline h2 {
    text-align: center;
    margin: 0;
    padding: 20px 20px 0 20px
}

.ub_call_to_action_content {
    width: 100%;
    padding: 0 0 15px 0
}

.ub_call_to_action_content p {
    text-align: justify
}

.ub_cta_button {
    margin-bottom: -31px !important;
    padding: 20px !important;
    position: relative;
    box-sizing: border-box;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border-radius: 3px
}

.ub_cta_button_text {
    margin: 0 !important;
    text-align: center
}

@media(max-width: 1199.98px) {
    .ub_call_to_action {
        padding: 0 30px
    }
}

@media(max-width: 991.98px) {
    .ub_call_to_action {
        padding: 0 20px;
        margin-bottom: 60px !important
    }
    .ub_call_to_action_headline {
        padding: 20px 0 0 0
    }
    .ub_call_to_action_headline p {
        line-height: 1.3;
        padding: 20px 0
    }
}

@media(max-width: 320px) {
    .ub_call_to_action_button .ub_cta_button_text {
        font-size: 14px !important;
        font-weight: 600
    }
    .ub_call_to_action {
        padding: 0 10px
    }
}

.wp-block-ub-block-click-to-tweet {
    margin: 0 auto;
    max-width: 100%
}

.ub_click_to_tweet {
    width: 95%;
    border: 1px solid;
    border-radius: 4px;
    padding: 10px;
    margin: 25px 0px
}

.ub_tweet {
    padding: 10px;
    margin-left: 10px;
    font-family: "Segoe UI", Arial, sans-serif
}

.ub_click_tweet {
    text-align: right;
    padding: 10px;
    margin-right: 10px
}

.ub_click_tweet>span {
    display: inline-block
}

.ub_click_tweet i {
    display: inline-block;
    width: 16px;
    height: 14px;
    background: url("../src/blocks/click-to-tweet/icons/sprite-twitter.png") no-repeat;
    background-position-x: 0%;
    background-position-y: 0%;
    margin-right: 3px;
    position: relative;
    top: 0;
    background-position: 0 -151px;
    width: 25px;
    height: 20px
}

@media(max-width: 479.98px) {
    .ub_click_tweet {
        width: 100%;
        float: none;
        padding: 0;
        margin: 10px 0 !important
    }
    .ub_tweet {
        padding: 0;
        margin-left: 0;
        line-height: 1.5
    }
}

.ub-hide {
    display: none
}

.ub-hiding {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0
}

.ub-toggle-transition {
    transition: all .5s ease-in-out
}

.ub-icon-holder {
    position: relative;
    transform: translate(-25%, 25%)
}

.ub-custom-id-input {
    font-size: .9em
}

@media(max-width: 699px) {
    .ub-mobile-hide {
        display: none
    }
    .ub-mobile-display {
        display: block
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .ub-tablet-hide {
        display: none
    }
    .ub-tablet-display {
        display: block
    }
}

.ub-content-filter-tag {
    display: inline-block;
    min-height: 32px;
    min-width: 100px;
    margin: 5px 10px 5px 0;
    padding: 8px;
    border-radius: 3px;
    text-align: center
}

.ub-content-filter-category-name {
    font-size: 1.625em;
    font-weight: 800;
    margin-bottom: 15px
}

.ub-content-filter-category {
    margin-bottom: 10px;
    padding: 3px
}

.ub-content-filter-tag {
    cursor: pointer
}

.ub-hide {
    display: none
}

.ub-hiding {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0
}

.ub-toggle-transition {
    transition: all .5s ease-in-out
}

.ub-icon-holder {
    position: relative;
    transform: translate(-25%, 25%)
}

.ub-custom-id-input {
    font-size: .9em
}

@media(max-width: 699px) {
    .ub-mobile-hide {
        display: none
    }
    .ub-mobile-display {
        display: block
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .ub-tablet-hide {
        display: none
    }
    .ub-tablet-display {
        display: block
    }
}

.wp-block-ub-content-toggle {
    margin: 20px 0 20px 0;
    max-width: 100%;
    width:100%;
}

.wp-block-ub-content-toggle-accordion {
    position: relative;

    margin-bottom: 10px
}

.wp-block-ub-content-toggle-accordion.no-border {
    border: 0 !important
}

.wp-block-ub-content-toggle-accordion .wp-block-ub-content-toggle-accordion-title {
    padding: 10px 10px 10px 25px;
    margin: 0;
    display: block
}

.wp-block-ub-content-toggle-accordion-content {
    padding: 25px
}

.wp-block-ub-content-toggle-accordion-controls-top {
    position: absolute;
    top: -10px;
    left: 0;
    right: 0;
    justify-content: center;
    display: flex;
    opacity: 0;
    transition: .5s opacity ease-in-out
}

.wp-block-ub-content-toggle-accordion-controls-top>span {
    display: inline-block;
    margin: 0 3px
}

.wp-block-ub-content-toggle-accordion-controls-bottom {
    position: absolute;
    bottom: -10px;
    left: 0;
    right: 0;
    justify-content: center;
    display: flex;
    opacity: 0;
    transition: .5s opacity ease-in-out
}

.wp-block-ub-content-toggle-accordion-controls-bottom>span {
    display: inline-block;
    margin: 0 3px
}

.wp-block-ub-content-toggle-accordion-title-wrap {
    display: flex;
    align-items: center;
    background: var(--illiniDarkBlue);
    color: var(--white);
    cursor: pointer
}

.wp-block-ub-content-toggle-accordion-title-wrap>*:first-child {
    flex-grow: 1
}

.wp-block-ub-content-toggle-accordion-title-wrap .wp-block-ub-content-toggle-accordion-toggle-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center
}

.wp-block-ub-content-toggle-accordion-title-wrap .wp-block-ub-content-toggle-accordion-toggle-wrap.left {
    order: -1
}

.wp-block-ub-content-toggle-accordion-title-wrap .wp-block-ub-content-toggle-accordion-toggle-wrap.right {
    order: 0
}

.wp-block-ub-content-toggle-accordion-title-wrap .wp-block-ub-content-toggle-accordion-toggle-wrap .wp-block-ub-content-toggle-accordion-toggle-location {
    position: absolute;
    left: 0;
    right: 0;
    top: 150%;
    opacity: 0;
    transition: .5s opacity ease-in-out;
    text-align: center;
    color: #191e23
}

.wp-block-ub-content-toggle-accordion-title-wrap .wp-block-ub-content-toggle-accordion-state-indicator {
    display: block;
    margin: 0 10px;
    transition: .5s all;
    transform: rotate(0deg);
    color: inherit
}

.wp-block-ub-content-toggle-accordion-title-wrap .wp-block-ub-content-toggle-accordion-state-indicator.open {
    transform: rotate(90deg)
}

.wp-block-ub-content-toggle-accordion-content-wrap {
    box-sizing: border-box;
    padding: 13px 4%;
    overflow: hidden
}

.wp-block-ub-content-toggle-accordion-content-wrap.ub-hiding {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0
}

.wp-block-ub-content-toggle-accordion:hover .wp-block-ub-content-toggle-accordion-controls-top,
.wp-block-ub-content-toggle-accordion:hover .wp-block-ub-content-toggle-accordion-controls-bottom,
.wp-block-ub-content-toggle-accordion:hover .wp-block-ub-content-toggle-accordion-toggle-location {
    opacity: 1 !important
}

@media(max-width: 479.98px) {
    .wp-block-ub-content-toggle-accordion .wp-block-ub-content-toggle-accordion-title {
        padding: 10px
    }
}

@media(max-width: 374.98px) {
    .wp-block-ub-content-toggle-accordion .wp-block-ub-content-toggle-accordion-title {
        padding: 10px 0 10px 10px
    }
    .wp-block-ub-content-toggle-accordion-content-wrap p {
        margin: 15px 0 10px
    }
}

.wp-block-ub-chevron-down {
    box-sizing: border-box;
    position: relative;
    display: block;
    transform: scale(var(--ggs, 1));
    width: 22px;
    height: 22px;
    border: 2px solid rgba(0, 0, 0, 0);
    border-radius: 100px
}

.wp-block-ub-chevron-down::after {
    content: "";
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 10px;
    height: 10px;
    border-bottom: 2px solid;
    border-right: 2px solid;
    transform: rotate(-45deg);
    left: 4px;
    top: 2px
}

.wp-block-ub-math-plus,
.wp-block-ub-math-plus::after {
    display: block;
    box-sizing: border-box;
    background: currentColor;
    border-radius: 10px
}

.wp-block-ub-math-plus {
    margin-top: -2px;
    position: relative;
    transform: scale(var(--ggs, 1));
    width: 16px;
    height: 2px
}

.wp-block-ub-math-plus.open {
    background-color: rgba(0, 0, 0, 0)
}

.wp-block-ub-math-plus::after {
    content: "";
    position: absolute;
    width: 2px;
    height: 16px;
    top: -7px;
    left: 7px
}

.wp-block-ub-math-plus+.wp-block-ub-content-toggle-accordion-toggle-location {
    margin-top: 60px
}

.ub_countdown_circular_container {
    display: grid
}

.ub_countdown_circular_container p {
    text-align: center
}

.ub_countdown_circular_container>div {
    margin: 0 auto
}

.ub_countdown_circular_container>div svg {
    position: absolute
}

.ub_countdown_circle_path {
    stroke-linecap: round;
    stroke-dashoffset: 0px;
    transition: stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s ease 0s, stroke-width .06s ease .3s;
    fill-opacity: 0
}

.ub_countdown_circle_trail {
    stroke: #d9d9d9;
    stroke-dasharray: 219.911px, 219.911px;
    stroke-dashoffset: 0px;
    transition: stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s ease 0s;
    fill-opacity: 0
}

.ub_countdown_circle_label {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
    text-align: center
}


.ub-countdown-separator {
    margin: 0 auto;
    font-size: 35px
}

.ub-countdown-odometer-container {
    display: grid
}

.ub-countdown-odometer-container span {
    text-align: center
}

.ub-countdown-digit-container {
    height: 1.5em;
    overflow-y: hidden;
    margin: 0 auto;
    font-size: 35px
}

.ub-countdown-digit-container>.digit,
.ub-countdown-digit-container>.moving-digit {
    float: left
}

.ub-countdown-odometer {
    margin: 0 auto;
    font-size: 35px
}

.ub-countdown-odometer-digit,
.ub-countdown-odometer-digits {
    float: left
}

.ub_countdown_style_selector {
    display: flex;
    flex-direction: row
}

.ub-countdown {
    margin-bottom: 20px
}

.ub-countdown>div {
    text-align: initial
}

@media(max-width: 991.98px) {
    .ub-countdown .ub_countdown_week,
    .ub-countdown .ub_countdown_day,
    .ub-countdown .ub_countdown_hour,
    .ub-countdown .ub_countdown_minute,
    .ub-countdown .ub_countdown_second,
    .ub-countdown-odometer-container span {
        font-size: 14px !important
    }
}

@media(max-width: 575.98px) {
    .ub-countdown .ub_countdown_week,
    .ub-countdown .ub_countdown_day,
    .ub-countdown .ub_countdown_hour,
    .ub-countdown .ub_countdown_minute,
    .ub-countdown .ub_countdown_second {
        margin: 0 1px;
        font-size: 16px !important
    }
}

@media(max-width: 479.98px) {
    .ub-countdown-separator,
    .ub-countdown-odometer {
        font-size: 20px
    }
    .ub-countdown {
        margin-bottom: 20px;
        font-size: 14px;
        display: inline-flex
    }
    .ub-countdown .ub_countdown_week,
    .ub-countdown .ub_countdown_day,
    .ub-countdown .ub_countdown_hour,
    .ub-countdown .ub_countdown_minute,
    .ub-countdown .ub_countdown_second {
        font-size: 14px !important
    }
    .ub_countdown_circular_container>div {
        height: 60px;
        width: 60px
    }
    .ub_countdown_circular_container>div svg {
        width: 60px;
        height: 60px
    }
}

@media(max-width: 374.98px) {
    .ub_countdown_circular_container div {
        height: 50px;
        width: 50px
    }
    .ub_countdown_circular_container>div svg {
        width: 50px;
        height: 50px
    }
    .ub-countdown .ub_countdown_week,
    .ub-countdown .ub_countdown_day,
    .ub-countdown .ub_countdown_hour,
    .ub-countdown .ub_countdown_minute,
    .ub-countdown .ub_countdown_second,
    .ub-countdown-odometer-container span,
    .ub-countdown {
        font-size: 10px !important
    }
}

@media(max-width: 320px) {
    .ub-countdown,
    .ub-countdown-separator,
    .ub-countdown-odometer {
        font-size: 10px
    }
    .ub_countdown_circular_container>div {
        height: 40px;
        width: 40px
    }
    .ub_countdown_circular_container>div svg {
        width: 40px;
        height: 40px
    }
    .ub-countdown .ub_countdown_week,
    .ub-countdown .ub_countdown_day,
    .ub-countdown .ub_countdown_hour,
    .ub-countdown .ub_countdown_minute,
    .ub-countdown .ub_countdown_second {
        margin: 0;
        font-size: 10px !important
    }
}

.ub_divider {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    align-content: center;
    border-bottom: none
}

.ub_divider.ub_divider:not(.alignwide):not(.alignfull):not(.alignleft):not(.alignright):not(.wp-block-separator):not(.woocommerce) {
    max-width: initial
}

.entry-content.entry-content .ub_divider {
    background-color: rgba(0, 0, 0, 0)
}

.entry-content.entry-content .ub_divider::before,
.entry-content.entry-content .ub_divider::after {
    content: none
}

.ub-expand {
    padding-bottom: 1em
}

.ub-expand-toggle-button {
    display: block;
    cursor: pointer
}

.ub-hide {
    display: none
}

.wp-block-ub-feature-box {
    margin: 20px 0 20px 0;
    max-width: 100%
}

.ub_feature_box {
    display: flex;
    margin: 1rem 0
}

.ub_feature_box>div {
    text-align: justify;
    margin: 0 auto
}

.ub_feature_box.column_1 .ub_feature_2,
.ub_feature_box.column_1 .ub_feature_3 {
    display: none
}

.ub_feature_box.column_1>div {
    width: 100%;
    margin-left: .5rem;
    margin-right: .5rem;
    padding: 1rem
}

.ub_feature_box.column_2 .ub_feature_3 {
    display: none
}

.ub_feature_box.column_2>div {
    width: 49%;
    margin-left: .5rem;
    margin-right: .5rem;
    padding: 1rem
}

.ub_feature_box.column_3>div {
    width: 33.2%;
    margin-left: .5rem;
    margin-right: .5rem;
    padding: 1rem
}

.ub_feature_box.column_3>div:first-child {
    margin-left: 0
}

.ub_feature_box.column_3>div:last-child {
    margin-right: 0
}

.ub_feature_box_feature {
    border-radius: 100px;
    overflow: hidden;
    border: medium none;
    max-width: 80px;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-top: -60px !important;
    margin-bottom: 25px
}

.ub_feature_one_feature,
.ub_feature_two_feature,
.ub_feature_three_feature {
    font-size: 40px !important;
    text-align: center;
    line-height: 80px !important;
    margin: 0 auto !important
}

.ub_feature_one_title,
.ub_feature_two_title,
.ub_feature_three_title {
    font-size: 30px !important;
    text-align: center;
    margin: 20px 0 !important;
    padding: 0
}

.ub_feature_1>img,
.ub_feature_2>img,
.ub_feature_3>img {
    display: flex;
    align-items: center;
    margin-right: auto;
    margin-left: auto;
    max-width: 100%
}

@media screen and (max-width: 800px) {
    .ub_feature_box.column_3 {
        display: block
    }
    .ub_feature_box.column_3>div {
        width: 90% !important;
        margin: 0 !important
    }
}

@media screen and (max-width: 600px) {
    .ub_feature_box.column_2 {
        display: block
    }
    .ub_feature_box.column_2>div {
        width: 90% !important;
        margin: 0 !important
    }
}

.ub_howto-step-image,
.ub_howto-yield-image {
    width: 100%
}

.ub_howto-supplies-list img,
.ub_howto-tools-list img {
    max-width: 200px
}

.ub_howto-section-display {
    margin-left: 1em
}

.ub_howto figcaption {
    margin-top: 5px;
    text-align: center
}

.ub_howto-step-display .ub_howto-step {
    list-style-position: outside
}

.ub_howto-step {
    overflow: auto
}

.ub_howto-step>figure,
.ub_howto-step>img {
    margin-bottom: 10px
}

.ub_howto-yield {
    overflow: auto
}

@media screen and (max-width: 767px) {
    .ub_howto .ub_howto-steps-list .ub_howto-step>figure,
    .ub_howto .ub_howto-section .ub_howto-steps-list .ub_howto-step>figure,
    .ub_howto .ub_howto-step-display .ub_howto-step>figure,
    .ub_howto .ub_howto-section .ub_howto-step-display .ub_howto-step>figure {
        width: 100%;
        float: none
    }
}

.ub_image_slider {
    margin-bottom: 30px
}

.ub_image_slider .ub_image_slider_image_caption {
    display: block;
    text-align: center
}

.ub_image_slider .ub_image_slider_alt {
    font-size: .8em
}

.ub_image_slider .swiper-slide>img,
.ub_image_slider .swiper-slide>picture>img,
.ub_image_slider .swiper-slide figure>img,
.ub_image_slider .swiper-slide figure>picture>img {
    display: block;
    margin: auto
}

@font-face {
    font-family: "swiper-icons";
    src: url("data:application/font-woff;charset=utf-8;base64, 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") format("woff");
    font-weight: 400;
    font-style: normal
}

:root {
    --swiper-theme-color: #007aff
}

.swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1
}

.swiper-container-vertical>.swiper-wrapper {
    flex-direction: column
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box
}

.swiper-container-android .swiper-slide,
.swiper-wrapper {
    transform: translate3d(0px, 0, 0)
}

.swiper-container-multirow>.swiper-wrapper {
    flex-wrap: wrap
}

.swiper-container-multirow-column>.swiper-wrapper {
    flex-wrap: wrap;
    flex-direction: column
}

.swiper-container-free-mode>.swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto
}

.swiper-container-pointer-events {
    touch-action: pan-y
}

.swiper-container-pointer-events.swiper-container-vertical {
    touch-action: pan-x
}

.swiper-slide {
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: transform
}

.swiper-slide-invisible-blank {
    visibility: hidden
}

.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
    height: auto
}

.swiper-container-autoheight .swiper-wrapper {
    align-items: flex-start;
    transition-property: transform, height
}

.swiper-container-3d {
    perspective: 1200px
}

.swiper-container-3d .swiper-wrapper,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-cube-shadow {
    transform-style: preserve-3d
}

.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10
}

.swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))
}

.swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))
}

.swiper-container-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))
}

.swiper-container-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))
}

.swiper-container-css-mode>.swiper-wrapper {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none
}

.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar {
    display: none
}

.swiper-container-css-mode>.swiper-wrapper>.swiper-slide {
    scroll-snap-align: start start
}

.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper {
    scroll-snap-type: x mandatory
}

.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper {
    scroll-snap-type: y mandatory
}

:root {
    --swiper-navigation-size: 44px
}

.swiper-button-prev,
.swiper-button-next {
    position: absolute;
    top: 50%;
    width: calc(var(--swiper-navigation-size)/44*27);
    height: var(--swiper-navigation-size);
    margin-top: calc(0px - var(--swiper-navigation-size)/2);
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--swiper-navigation-color, var(--swiper-theme-color))
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
    opacity: .35;
    cursor: auto;
    pointer-events: none
}

.swiper-button-prev:after,
.swiper-button-next:after {
    font-family: swiper-icons;
    font-size: var(--swiper-navigation-size);
    text-transform: none !important;
    letter-spacing: 0;
    text-transform: none;
    font-variant: initial;
    line-height: 1
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
    left: 10px;
    right: auto
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
    content: "prev"
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
    right: 10px;
    left: auto
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
    content: "next"
}

.swiper-button-prev.swiper-button-white,
.swiper-button-next.swiper-button-white {
    --swiper-navigation-color: #ffffff
}

.swiper-button-prev.swiper-button-black,
.swiper-button-next.swiper-button-black {
    --swiper-navigation-color: #000000
}

.swiper-button-lock {
    display: none
}

.swiper-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10
}

.swiper-pagination.swiper-pagination-hidden {
    opacity: 0
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal>.swiper-pagination-bullets {
    bottom: 10px;
    left: 0;
    width: 100%
}

.swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transform: scale(0.33);
    position: relative
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    transform: scale(1)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
    transform: scale(1)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    transform: scale(0.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    transform: scale(0.33)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    transform: scale(0.66)
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    transform: scale(0.33)
}

.swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    background: #000;
    opacity: .2
}

button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    appearance: none
}

.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer
}

.swiper-pagination-bullet:only-child {
    display: none !important
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: var(--swiper-pagination-color, var(--swiper-theme-color))
}

.swiper-container-vertical>.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    transform: translate3d(0px, -50%, 0)
}

.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 6px 0;
    display: block
}

.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    transform: translateY(-50%);
    width: 8px
}

.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    display: inline-block;
    transition: 200ms transform, 200ms top
}

.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 4px
}

.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap
}

.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: 200ms transform, 200ms left
}

.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    transition: 200ms transform, 200ms right
}

.swiper-pagination-progressbar {
    background: rgba(0, 0, 0, .25);
    position: absolute
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: var(--swiper-pagination-color, var(--swiper-theme-color));
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transform: scale(0);
    transform-origin: left top
}

.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    transform-origin: right top
}

.swiper-container-horizontal>.swiper-pagination-progressbar,
.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0
}

.swiper-container-vertical>.swiper-pagination-progressbar,
.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0
}

.swiper-pagination-white {
    --swiper-pagination-color: #ffffff
}

.swiper-pagination-black {
    --swiper-pagination-color: #000000
}

.swiper-pagination-lock {
    display: none
}

.swiper-container-cube {
    overflow: visible
}

.swiper-container-cube .swiper-slide {
    pointer-events: none;
    backface-visibility: hidden;
    z-index: 1;
    visibility: hidden;
    transform-origin: 0 0;
    width: 100%;
    height: 100%
}

.swiper-container-cube .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
    transform-origin: 100% 0
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-next,
.swiper-container-cube .swiper-slide-prev,
.swiper-container-cube .swiper-slide-next+.swiper-slide {
    pointer-events: auto;
    visibility: visible
}

.swiper-container-cube .swiper-slide-shadow-top,
.swiper-container-cube .swiper-slide-shadow-bottom,
.swiper-container-cube .swiper-slide-shadow-left,
.swiper-container-cube .swiper-slide-shadow-right {
    z-index: 0;
    backface-visibility: hidden
}

.swiper-container-cube .swiper-cube-shadow {
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 100%;
    opacity: .6;
    z-index: 0
}

.swiper-container-cube .swiper-cube-shadow:before {
    content: "";
    background: #000;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    -webkit-filter: blur(50px);
    filter: blur(50px)
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
    transition-timing-function: ease-out
}

.swiper-container-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity
}

.swiper-container-fade .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-fade .swiper-slide-active,
.swiper-container-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-flip {
    overflow: visible
}

.swiper-container-flip .swiper-slide {
    pointer-events: none;
    backface-visibility: hidden;
    z-index: 1
}

.swiper-container-flip .swiper-slide .swiper-slide {
    pointer-events: none
}

.swiper-container-flip .swiper-slide-active,
.swiper-container-flip .swiper-slide-active .swiper-slide-active {
    pointer-events: auto
}

.swiper-container-flip .swiper-slide-shadow-top,
.swiper-container-flip .swiper-slide-shadow-bottom,
.swiper-container-flip .swiper-slide-shadow-left,
.swiper-container-flip .swiper-slide-shadow-right {
    z-index: 0;
    backface-visibility: hidden
}

.ub_notify_info,
.ub_notify_success,
.ub_notify_warning {
    margin: 10px 0px;
    padding: 15px;
    border-left-width: 4px;
    border-left-style: solid
}

.ub_notify_info .ub_notify_text,
.ub_notify_success .ub_notify_text,
.ub_notify_warning .ub_notify_text {
    margin: 0 auto
}

.ub_notify_info {
    color: #31708f;
    background-color: #d9edf7;
    border-left-color: #31708f
}

.ub_notify_success {
    color: #3c763d;
    background-color: #dff0d8;
    border-left-color: #3c763d
}

.ub_notify_warning {
    color: #d8000c;
    background-color: #ffd2d2;
    border-left-color: #d8000c
}

.wp-block-ub-number-box {
    margin: 50px 0 50px 0;
    max-width: 100%
}

.ub_number_box {
    display: flex;
    margin: 1rem 0;
    margin-top: 5rem
}

.ub_number_box>div {
    text-align: justify;
    margin: 0 auto
}

.ub_number_box.column_1 .ub_number_2,
.ub_number_box.column_1 .ub_number_3 {
    display: none
}

.ub_number_box.column_1>div {
    width: 100%;
    margin-left: .5rem;
    margin-right: .5rem;
    border: 1px solid;
    padding: 1rem
}

.ub_number_box.column_2 .ub_number_3 {
    display: none
}

.ub_number_box.column_2>div {
    width: 49%;
    margin-left: .5rem;
    margin-right: .5rem;
    border: 1px solid;
    padding: 1rem
}

.ub_number_box.column_3>div {
    width: 33.2%;
    margin-left: .5rem;
    margin-right: .5rem;
    border: 1px solid;
    padding: 1rem
}

.ub_number_box.column_3>div:first-child {
    margin-left: 0
}

.ub_number_box.column_3>div:last-child {
    margin-right: 0
}

.ub_number_box_number {
    border-radius: 100px;
    overflow: hidden;
    border: medium none;
    max-width: 80px;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-top: -60px !important;
    margin-bottom: 25px
}

.ub_number_one_number,
.ub_number_two_number,
.ub_number_three_number {
    font-size: 40px !important;
    text-align: center;
    line-height: 80px !important;
    margin: 0 auto !important
}

.ub_number_one_title,
.ub_number_two_title,
.ub_number_three_title {
    font-size: 30px !important;
    text-align: center;
    margin: 10px auto;
    padding: 0
}

@media screen and (max-width: 800px) {
    .ub_number_box.column_3 {
        display: block
    }
    .ub_number_box.column_3>div {
        width: 92% !important;
        margin: 0 !important
    }
}

@media screen and (max-width: 600px) {
    .ub_number_box.column_2 {
        display: block
    }
    .ub_number_box.column_2>div {
        width: 90% !important;
        margin: 0 !important
    }
}

.ub-hide {
    display: none
}

.ub-hiding {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0
}

.ub-toggle-transition {
    transition: all .5s ease-in-out
}

.ub-icon-holder {
    position: relative;
    transform: translate(-25%, 25%)
}

.ub-custom-id-input {
    font-size: .9em
}

@media(max-width: 699px) {
    .ub-mobile-hide {
        display: none
    }
    .ub-mobile-display {
        display: block
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .ub-tablet-hide {
        display: none
    }
    .ub-tablet-display {
        display: block
    }
}

.ub-block-post-grid {
    margin: 0 0 1.2em 0;
    position: relative
}

.ub-block-post-grid .is-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 0 2em
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-grid {
        display: block
    }
}

.ub-block-post-grid .is-grid article {
    margin-bottom: 2.5em;
    min-width: 0;
    padding: 0
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-grid article {
        padding-left: 10px;
        padding-right: 10px;
        display: inline-block;
        vertical-align: top
    }
}

.ub-block-post-grid .is-grid.columns-1 {
    grid-template-columns: 1fr
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-grid.columns-1 article {
        width: 100%
    }
}

.ub-block-post-grid .is-grid.columns-2 {
    grid-template-columns: 1fr 1fr
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-grid.columns-2 article {
        width: 48%
    }
}

.ub-block-post-grid .is-grid.columns-3 {
    grid-template-columns: 1fr 1fr 1fr
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-grid.columns-3 article {
        width: 32%
    }
}

@media only screen and (max-width: 600px) {
    .ub-block-post-grid div[class*=columns].is-grid {
        grid-template-columns: 1fr
    }
}

.ub-block-post-grid .ub_block-post-grid-text {
    text-align: left
}

.ub-block-post-grid a {
    text-decoration: none
}

.ub-block-post-grid .ub-block-post-grid-image {
    margin-bottom: 1.2em
}

.ub-block-post-grid .ub-block-post-grid-image img {
    display: block;
    width: 100%
}

.ub-block-post-grid header .ub-block-post-grid-title {
    margin-top: 0;
    margin-bottom: 15px;
    line-height: 1.2
}

.ub-block-post-grid header .ub-block-post-grid-title a {
    color: #292929;
    text-decoration: none
}

.ub-block-post-grid header .ub-block-post-grid-title a:hover {
    text-decoration: underline;
    color: inherit
}

.ub-block-post-grid .ub-block-post-grid-author,
.ub-block-post-grid .ub-block-post-grid-date {
    display: inline-block
}

.ub-block-post-grid .ub-block-post-grid-author:not(:last-child):after,
.ub-block-post-grid .ub-block-post-grid-date:not(:last-child):after {
    content: "";
    vertical-align: middle;
    margin: 0 5px;
    line-height: 1
}

.ub-block-post-grid .ub-block-post-grid-author a {
    color: inherit;
    text-decoration: none
}

.ub-block-post-grid .ub-block-post-grid-author a:hover {
    color: inherit;
    text-decoration: underline
}

.ub-block-post-grid .ub-block-post-grid-more-link {
    display: inline-block;
    box-shadow: none;
    transition: .3s ease;
    font-weight: bold;
    color: #292929;
    text-decoration: none
}

.ub-block-post-grid .ub-block-post-grid-more-link:hover {
    text-decoration: underline
}

.ub-block-post-grid .ub-block-post-grid-excerpt>p:last-child {
    margin-top: 15px;
    margin-bottom: 0
}

.ub-block-post-grid .is-list article {
    display: grid;
    grid-template-columns: 30% 1fr;
    grid-template-rows: 1fr;
    grid-gap: 0 2em;
    padding: 0
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-list article {
        display: block
    }
}

.ub-block-post-grid .is-list article:before {
    display: none
}

.ub-block-post-grid .is-list article:not(:last-child) {
    margin-bottom: 5%;
    padding-bottom: 5%
}

.ub-block-post-grid .is-list article:not(.has-post-thumbnail) {
    grid-template-columns: 1fr
}

@media only screen and (min-width: 600px) {
    .ub-block-post-grid .is-list article:not(:last-child) {
        border-bottom: solid 1px #eee
    }
}

@media only screen and (max-width: 600px) {
    .ub-block-post-grid .is-list article {
        grid-template-columns: 1fr
    }
}

.ub-block-post-grid .is-list .ub-block-post-grid-image {
    margin-bottom: 0
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-list .ub-block-post-grid-image {
        width: 30%;
        display: inline-block;
        vertical-align: top
    }
}

@media only screen and (max-width: 600px) {
    .ub-block-post-grid .is-list .ub-block-post-grid-image {
        margin-bottom: 5%
    }
}

@media all and (-ms-high-contrast: none) {
    .ub-block-post-grid .is-list .ub-block-post-grid-text {
        width: 65%;
        padding-left: 5%;
        display: inline-block;
        vertical-align: top
    }
    .ub-block-post-grid .is-list .post:not(.has-post-thumbnail) .ub-block-post-grid-text {
        width: 100%;
        padding-left: 0
    }
}

.ub-block-post-grid .is-list .no-thumb .ub-block-post-grid-text {
    grid-column: span 2
}

.ub-block-post-grid-image {
    position: relative
}

.ub-block-post-grid-image:hover .ub-post-grid-no-image-placeholder {
    opacity: 1;
    z-index: 1
}

.ub-post-grid-no-image-placeholder {
    padding: 40px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background: #f3f3f4;
    transition: .2s ease
}

.ub-post-grid-no-image-placeholder svg {
    margin-bottom: 10px
}

.ub-post-grid-no-image-icon {
    position: absolute;
    top: 10px;
    background: #ffe606;
    right: 10px;
    padding: 6px;
    line-height: 1;
    height: 32px;
    transition: .2s ease;
    border-radius: 5px;
    z-index: 1
}

.ub_progress-bar {
    overflow: auto
}

.ub_progress-bar-container {
    text-align: start
}

.ub_progress-bar-circle {
    position: absolute
}

.ub_progress-bar-circle+.ub_progress-bar-label {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
    text-align: center
}

.ub_progress-bar-circle-trail {
    stroke-dashoffset: 0px;
    transition: stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s ease 0s;
    fill-opacity: 0
}

.ub_progress-bar-circle-path {
    stroke-dashoffset: 0px;
    transition: stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s ease 0s, stroke-width .06s ease .3s;
    fill-opacity: 0
}

.ub_progress-bar-line-trail {
    fill-opacity: 0;
    stroke-linecap: round
}

.ub_progress-bar-line-path {
    stroke-dasharray: 100px, 100px;
    transition: stroke-dashoffset .3s ease 0s, stroke .3s linear 0s;
    fill-opacity: 0;
    stroke-linecap: round
}

.ub_progress-bar-line+.ub_progress-bar-label {
    text-align: right;
    min-width: 24px
}

.ub_review_block {
    padding: 35px 40px;
    box-shadow: 0px 0px 4px 1px #d6d6d6;
    border-radius: 5px;
    margin: 30px auto
}

.ub_review_block svg:not(:root) {
    margin: 0 1px
}

.ub_review_block svg:not(:root):first-child {
    margin-left: 0
}

.ub_review_block svg:not(:root):last-child {
    margin-right: 0
}

.ub_review_block .ub_review_image {
    margin-top: 10px;
    float: right;
    object-fit: contain
}

.ub_review_overall_value {
    display: grid;
    grid-template-columns: 75% 25%
}

.ub_review_entry,
.ub_review_percentage_entry {
    padding: 10px 0 10px 0;
    border-bottom: 1px solid #e9e9e9
}

.ub_review_entry {
    display: flex
}

.ub_review_percentage_entry {
    display: grid;
    grid-template-columns: 25% 75%
}

.ub_review_rating {
    text-align: right;
    font-size: 40px
}

.ub_review_average {
    display: flex;
    flex-direction: column
}

.ub_review_average_stars {
    display: flex;
    grid-area: auto;
    justify-self: self-end;
    height: 50px;
    line-height: 60px;
    margin-left: auto;
    align-items: center
}

.ub_review_cta_panel {
    display: grid;
    grid-template-columns: 2fr auto;
    grid-template-areas: "cta . stars"
}

.ub_review_add_entry {
    left: 50%;
    width: 100%
}

.ub_review_link_input {
    display: flex;
    flex-direction: row
}

.ub_review_cta_btn {
    min-width: 100px;
    padding: 15px 10px;
    border-radius: 6px;
    display: inline-block;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    text-transform: none;
    cursor: pointer;
    font-weight: normal;
    background-image: none
}

.ub_review_cta_btn:hover,
.ub_review_cta_btn:active {
    background-image: none
}

.ub_review_item_name {
    font-size: 28px !important;
    margin: 0 !important;
    font-weight: 600 !important
}

.ub_review_summary_title {
    margin: 23px 0 13px 0 !important;
    font-size: 24px !important;
    font-weight: 600 !important
}

.ub_review_stars {
    display: flex;
    margin-left: auto;
    padding-top: 3px
}

.ub_review_description {
    padding: 0
}

.ub_review_description_container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    overflow: auto
}

.ub_review_left_image {
    flex-direction: row
}

.ub_review_right_image {
    flex-direction: row-reverse
}

.ub_review_top_image {
    flex-direction: column
}

.ub_review_bottom_image {
    flex-direction: column-reverse
}

.ub_review_percentage {
    display: grid;
    grid-template-columns: 4fr 1fr;
    overflow: auto;
    margin-left: auto
}

.ub_review_percentage>svg {
    height: 10px
}

.ub_review_percentage>div {
    text-align: end
}

.ub_review_percentage_bar {
    width: 100%;
    align-self: center
}

.ub_review_percentage_bar_trail {
    fill-opacity: 0;
    stroke-linecap: round
}

.ub_review_percentage_bar_path {
    stroke-dasharray: 100px, 100px;
    transition: stroke-dashoffset .3s ease 0s, stroke .3s linear 0s;
    fill-opacity: 0;
    stroke-linecap: round
}

.ub_review_cta_main {
    display: flex
}

@media(max-width: 7688px) {
    .ub_review_block {
        padding: 35px 40px
    }
}

@media(max-width: 576px) {
    .ub_review_cta_btn {
        padding: 15px 10px
    }
    .ub_review_image {
        float: right
    }
}

@media(max-width: 480px) {
    .ub_review_rating {
        font-size: 20px;
        font-weight: 600
    }
    .ub_review_entry {
        font-size: 18px
    }
    .ub_review_cta_btn {
        padding: 15px 8px
    }
}

@media(max-width: 460px) {
    .ub_review_average_stars svg {
        width: 12px;
        height: 12px
    }
}

@media(max-width: 375px) {
    .ub_review_block {
        padding: 20px 15px
    }
    .ub_review_block button>svg {
        width: 12px;
        height: 12px
    }
}

@media(max-width: 320px) {
    .ub_review_block {
        padding: 20px 10px
    }
    .ub_review_block button>svg {
        width: 8px;
        height: 8px;
        margin: 0
    }
    .ub_review_average_stars {
        height: 45px;
        line-height: 40px;
        margin-left: auto
    }
}

.wp-block-ub-social-share .social-share-icons {
    display: flex;
    flex-wrap: wrap
}

.wp-block-ub-social-share .social-share-icons .social-share-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 7px
}

.wp-block-ub-social-share .social-share-icons .social-share-icon.circle {
    box-shadow: 0px 3px 2px gray;
    border-radius: 50%
}

.wp-block-ub-social-share .social-share-icons .social-share-icon.square {
    box-shadow: 0px 3px 2px gray;
    border-radius: 0%
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-standalone-icon {
    margin: 12px;
    padding-right: 5px
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-facebook-container {
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-twitter-container {
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-linkedin-container {
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-pinterest-container {
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-reddit-container {
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-tumblr-container {
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex
}

.wp-block-ub-social-share .social-share-icons>div {
    display: flex;
    align-items: center
}

.wp-block-ub-social-share .social-share-icons a {
    text-decoration: none
}

.align-icons-center {
    justify-content: center
}

.align-icons-left {
    justify-content: flex-start
}

.align-icons-right {
    justify-content: flex-end
}

.ub-social-share-facebook.square,
.ub-social-share-facebook.circle {
    background-color: #1877f2
}

.ub-social-share-facebook+span,
.ub-social-share-facebook+span>a {
    color: #1877f2
}

.ub-social-share-twitter.square,
.ub-social-share-twitter.circle {
    background-color: #1d9bf0
}

.ub-social-share-twitter+span,
.ub-social-share-twitter+span>a {
    color: #1d9bf0
}

.ub-social-share-linkedin.square,
.ub-social-share-linkedin.circle {
    background-color: #2867b2
}

.ub-social-share-linkedin+span,
.ub-social-share-linkedin+span>a {
    color: #2867b2
}

.ub-social-share-pinterest.square,
.ub-social-share-pinterest.circle {
    background-color: #e60023
}

.ub-social-share-pinterest+span,
.ub-social-share-pinterest+span>a {
    color: #e60023
}

.ub-social-share-reddit.square,
.ub-social-share-reddit.circle {
    background-color: #ff4500
}

.ub-social-share-reddit+span,
.ub-social-share-reddit+span>a {
    color: #ff4500
}

.ub-social-share-tumblr.square,
.ub-social-share-tumblr.circle {
    background-color: #001935
}

.ub-social-share-tumblr+span,
.ub-social-share-tumblr+span>a {
    color: #001935
}

.ub-star-outer-container {
    display: flex
}

.ub-star-inner-container,
.ub-star-container {
    display: flex;
    flex-direction: row;
    margin: 20px 0
}

.ub-star-inner-container svg {
    margin-top: initial
}

.ub-notification-box {
    margin: 10px 0px;
    padding: 15px;
    border-left-width: 4px;
    border-left-style: solid
}

.ub-notification-box>*:first-child {
    margin-top: 0
}

.ub-notification-box>*:last-child {
    margin-bottom: 0
}

.ub-feature-box,
.ub-number-box {
    display: flex;
    margin-top: 60px;
    margin-bottom: 30px
}

.ub-feature-box>div,
.ub-number-box>div {
    flex-basis: 100%;
    margin-left: .5rem;
    margin-right: .5rem;
    padding: 1rem
}

.ub-feature-box>div:first-child:nth-last-child(3),
.ub-number-box>div:first-child:nth-last-child(3) {
    margin-left: 0
}

.ub-feature-box>div:last-child:nth-child(3),
.ub-number-box>div:last-child:nth-child(3) {
    margin-right: 0
}

.ub-number-panel {
    border: 1px solid
}

.ub-number-box .ub-number-panel .ub-number-container {
    border-radius: 100px;
    overflow: hidden;
    border: medium none;
    max-width: 80px;
    margin: -60px auto 25px
}

.ub-number-box .ub-number-panel .ub-number-container .ub-number-display {
    font-size: 40px;
    text-align: center;
    line-height: 80px;
    margin: 0 auto
}

.ub-number-box .ub-number-panel .ub-number-box-title {
    font-size: 30px;
    text-align: center;
    margin: 10px auto;
    padding: 0
}

.ub-feature-box .ub-feature img {
    display: block;
    margin-left: auto;
    margin-right: auto
}

.ub-feature-box .ub-feature .ub-feature-title {
    font-size: 30px;
    text-align: center;
    margin: 20px 0;
    padding: 0
}

.ub-bordered-box {
    margin-bottom: 20px;
    padding: 20px
}

.ub-bordered-box>p:last-child {
    margin: 0
}

@media screen and (max-width: 800px) {
    .ub-feature-box,
    .ub-number-box {
        display: block
    }
    .ub-feature-box>div,
    .ub-number-box>div {
        width: 90%;
        margin: 0
    }
}

.ub_styled_list .fa-ul {
    list-style-type: none;
    margin-left: 1em;
    padding-left: 0;
    display: grid;
    column-gap: 2em
}

.ub_styled_list .fa-ul>li {
    position: relative;
    list-style: none;
    margin-left: .5em;
    margin-right: .5em
}

.ub_styled_list .fa-li {
    display: inline-block;
    left: -0.5em;
    position: relative
}

.ub_styled_list li::before {
    content: "";
    position: relative;
    left: -0.5em;
    display: inline-block;
    background-repeat: no-repeat
}

ul.ub_styled_list {
    list-style-type: none;
    margin-left: 1em;
    padding-left: 0
}

ul.ub_styled_list li {
    position: relative;
    list-style: none;
    margin-left: .5em;
    margin-right: .5em
}

.ub-hide {
    display: none
}

.ub-hiding {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0
}

.ub-toggle-transition {
    transition: all .5s ease-in-out
}

.ub-icon-holder {
    position: relative;
    transform: translate(-25%, 25%)
}

.ub-custom-id-input {
    font-size: .9em
}

@media(max-width: 699px) {
    .ub-mobile-hide {
        display: none
    }
    .ub-mobile-display {
        display: block
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .ub-tablet-hide {
        display: none
    }
    .ub-tablet-display {
        display: block
    }
}

.wp-block-ub-tabbed-content {
    margin-top: 30px;
    margin-bottom: 30px
}

.wp-block-ub-tabbed-content .wp-block-ub-tabbed-content-tabs-content {
    border: 1px solid #d3d3d3
}

.wp-block-ub-tabbed-content .wp-block-ub-tabbed-content-tab-title-wrap {
    border: 1px solid #d3d3d3;
    border-bottom: 0
}

.wp-block-ub-tabbed-content-holder .blocks-rich-text__tinymce.mce-content-body {
    font-size: 14px
}

.wp-block-ub-tabbed-content-holder.vertical-holder {
    display: flex
}

.wp-block-ub-tabbed-content-tab-holder {
    position: relative
}

.wp-block-ub-tabbed-content-tab-holder.vertical-tab-width {
    position: relative;
    width: 21%
}

.wp-block-ub-tabbed-content-tabs-title {
    display: flex;
    overflow-x: hidden
}

.wp-block-ub-tabbed-content-tabs-title:hover,
.wp-block-ub-tabbed-content-tabs-title:focus {
    overflow-x: auto
}

@media(max-width: 699px) {
    .wp-block-ub-tabbed-content-tabs-title.ub-mobile-hide {
        display: none
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .wp-block-ub-tabbed-content-tabs-title.ub-tablet-hide {
        display: none
    }
}

.wp-block-ub-tabbed-content-tabs-content {
    padding: 25px
}

.wp-block-ub-tabbed-content-tabs-content.vertical-content-width {
    width: 79%
}

.wp-block-ub-tabbed-content-tab-title {
    word-break: initial
}

.wp-block-ub-tabbed-content-tab-title-wrap {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: 10px 15px;
    margin-right: 5px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer
}

.wp-block-ub-tabbed-content-tab-title-wrap.active {
    color: #fff
}

.wp-block-ub-tabbed-content-tab-title-vertical-wrap {
    border: 1px solid #d3d3d3;
    border-top-left-radius: 5px;
    padding: 10px 15px;
    border-right: 0;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer
}

.wp-block-ub-tabbed-content-tab-title-vertical-wrap.active {
    color: #000
}

@media(max-width: 699px) {
    .ub-tabbed-content-mobile-accordion {
        padding: 0;
        border: none
    }
    .ub-tabbed-content-mobile-accordion>.wp-block-ub-tabbed-content-tab-content-wrap {
        border: 1px solid #d3d3d3;
        padding: 20px
    }
    .ub-tabbed-content-mobile-accordion>.wp-block-ub-tabbed-content-tab-content-wrap.active {
        border-color: #a9a9a9
    }
    .wp-block-ub-tabbed-content-tab-title-mobile-vertical-wrap {
        border: 1px solid #d3d3d3;
        border-top-left-radius: 5px;
        padding: 10px 15px;
        border-right: 0;
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer
    }
    .wp-block-ub-tabbed-content-tab-title-mobile-vertical-wrap.active {
        color: #000
    }
    .wp-block-ub-tabbed-content-tabs-content.vertical-content-width-mobile {
        width: 79%
    }
    .wp-block-ub-tabbed-content-tabs-content.horizontal-content-width-mobile {
        width: 100
    }
    .wp-block-ub-tabbed-content-tab-holder.vertical-tab-width-mobile {
        width: 21%
    }
    .wp-block-ub-tabbed-content-tab-holder.horizontal-tab-width-mobile {
        width: 100%
    }
    .wp-block-ub-tabbed-content-tabs-title-mobile-vertical-tab {
        display: initial
    }
    .wp-block-ub-tabbed-content-tabs-title-mobile-vertical-tab .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {
        border-bottom: 1px solid #d3d3d3
    }
    .wp-block-ub-tabbed-content-tabs-title-mobile-horizontal-tab {
        display: flex
    }
    .wp-block-ub-tabbed-content-tabs-title-mobile-horizontal-tab .wp-block-ub-tabbed-content-tab-title-vertical-wrap {
        border-right: 1px solid #d3d3d3
    }
    .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-mobile {
        display: block
    }
    .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-mobile>.wp-block-ub-tabbed-content-tabs-content {
        width: 100%
    }
    .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-vertical-holder-mobile {
        display: flex
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .ub-tabbed-content-tablet-accordion {
        padding: 0;
        border: none
    }
    .ub-tabbed-content-tablet-accordion>.wp-block-ub-tabbed-content-tab-content-wrap {
        border: 1px solid #d3d3d3;
        padding: 20px
    }
    .ub-tabbed-content-tablet-accordion>.wp-block-ub-tabbed-content-tab-content-wrap.active {
        border-color: #a9a9a9
    }
    .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {
        border: 1px solid #d3d3d3;
        border-top-left-radius: 5px;
        padding: 10px 15px;
        border-right: 0;
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer
    }
    .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap.active {
        color: #000
    }
    .wp-block-ub-tabbed-content-tabs-content.vertical-content-width-tablet {
        width: 79%
    }
    .wp-block-ub-tabbed-content-tabs-content.horizontal-content-width-tablet {
        width: 100%
    }
    .wp-block-ub-tabbed-content-tab-holder.vertical-tab-width-tablet {
        width: 21%
    }
    .wp-block-ub-tabbed-content-tab-holder.horizontal-tab-width-tablet {
        width: 100%
    }
    .wp-block-ub-tabbed-content-tabs-title-tablet-vertical-tab {
        display: initial
    }
    .wp-block-ub-tabbed-content-tabs-title-tablet-vertical-tab .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {
        border-bottom: 1px solid #d3d3d3
    }
    .wp-block-ub-tabbed-content-tabs-title-tablet-horizontal-tab {
        display: flex
    }
    .wp-block-ub-tabbed-content-tabs-title-tablet-horizontal-tab .wp-block-ub-tabbed-content-tab-title-vertical-wrap {
        border-right: 1px solid #d3d3d3
    }
    .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-tablet {
        display: block
    }
    .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-tablet>.wp-block-ub-tabbed-content-tabs-content {
        width: 100%
    }
    .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-vertical-holder-tablet {
        display: flex
    }
}

.wp-block-ub-tabbed-content-accordion-toggle {
    border: 1px solid #d3d3d3;
    padding: 10px 15px;
    display: none
}

.wp-block-ub-tabbed-content-accordion-toggle.active {
    border-bottom: none
}

@media(max-width: 699px) {
    .wp-block-ub-tabbed-content-accordion-toggle.ub-mobile-display {
        display: block
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .wp-block-ub-tabbed-content-accordion-toggle.ub-tablet-display {
        display: block
    }
}

@media(max-width: 374.98px) {
    .wp-block-ub-tabbed-content-tab-title-wrap {
        padding: 10px 5px
    }
    .wp-block-ub-tabbed-content-tabs-content {
        padding: 10px
    }
    .wp-block-ub-tabbed-content-tabs-content p {
        margin: 0 0 10px 0
    }
    .wp-block-ub-tabbed-content-scroll-button-container>button {
        top: -30px
    }
}

.ub-hide {
    display: none
}

.ub-hiding {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0
}

.ub-toggle-transition {
    transition: all .5s ease-in-out
}

.ub-icon-holder {
    position: relative;
    transform: translate(-25%, 25%)
}

.ub-custom-id-input {
    font-size: .9em
}

@media(max-width: 699px) {
    .ub-mobile-hide {
        display: none
    }
    .ub-mobile-display {
        display: block
    }
}

@media(min-width: 700px)and (max-width: 899px) {
    .ub-tablet-hide {
        display: none
    }
    .ub-tablet-display {
        display: block
    }
}

.ub_table-of-contents {
    box-sizing: border-box;
    transition: all .5s ease-in-out;
    background-color: #fafafa;
    border: 1px solid #dfdfdf;
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: grid
}

.ub_table-of-contents ul,
.ub_table-of-contents ol {
    margin-bottom: 0;
    margin-left: 1.3em;
    padding-inline-start: 0;
    padding-left: 0
}

.ub_table-of-contents ol {
    list-style-type: none;
    counter-reset: item;
    margin: 0;
    padding: 0
}

.ub_table-of-contents ol>li {
    display: table;
    counter-increment: item
}

.ub_table-of-contents ol>li:before {
    content: counters(item, ".") ". ";
    display: table-cell;
    padding-right: .6em
}

.ub_table-of-contents li ol>li {
    margin: 0
}

.ub_table-of-contents li ol>li:before {
    content: counters(item, ".") " "
}

.ub_table-of-contents-header {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    display: grid;
    grid-template-columns: minmax(10px, 1fr) auto;
    transition: all .5s ease-in-out
}

.ub_table-of-contents-header-toggle {
    display: flex;
    align-items: center;
    padding-left: 5px
}

.ub_table-of-contents-collapsed {
    padding: 10px
}

.ub_table-of-contents-1-column {
    column-count: 1
}

.ub_table-of-contents-2-column {
    column-count: 2
}

.ub_table-of-contents-3-column {
    column-count: 3
}

.ub_table-of-contents-container {
    transition: all .5s ease-in-out;
    overflow: hidden
}

.ub_table-of-contents .ub_table-of-contents-container ul>li:before {
    content: none
}

.ub_table-of-contents-header-container,
.ub_table-of-contents-extra-container {
    padding: 15px 30px;
    transition: all .5s ease-in-out
}

.ub_table-of-contents-header-container {
    display: grid
}

.ub_table-of-contents,
.ub_table-of-contents-collapsed {
    padding: 0
}

.ub_table-of-contents-collapsed .ub_table-of-contents-extra-container {
    padding: 0
}

@media screen and (max-width: 600px) {
    .ub_table-of-contents-1-column,
    .ub_table-of-contents-2-column,
    .ub_table-of-contents-3-column {
        column-count: 1
    }
}

.wp-block-ub-testimonial-block {
    margin: 30px auto;
    max-width: 100%
}

.ub_testimonial {
    max-width: 100%;
    padding: 30px;
    display: grid;
    grid-template-columns: fit-content(25%) auto;
    grid-template-rows: auto auto;
    margin: 40px 0
}

.ub_testimonial_img {
    padding: 10px 10px;
    grid-column-start: 1;
    grid-row-start: 1;
    grid-row-end: span 2
}

.ub_testimonial_img img {
    margin: 0 auto;
    padding: 0;
    border-radius: 50%
}

.ub_testimonial_content {
    grid-row-start: 1;
    grid-column-start: 2;
    padding: 11px 20px
}

.ub_testimonial_content p {
    font-style: italic
}

.ub_testimonial_sign {
    padding-right: 10px;
    padding-bottom: 10px;
    grid-column-start: 2;
    grid-row-start: 2
}

.ub_testimonial_sign p {
    margin-bottom: 2px !important
}

.ub_testimonial_sign .ub_testimonial_author_role {
    margin-top: 0;
    font-size: 13px;
    font-style: italic
}

@media(max-width: 479.98px) {
    .ub_testimonial {
        padding: 30px 10px;
        display: block
    }
    .ub_testimonial_img {
        padding: 0
    }
    .ub_testimonial_content {
        padding: 10px
    }
    .ub_testimonial_content p {
        text-align: center !important
    }
    .ub_testimonial_sign {
        padding-right: 0
    }
    .ub_testimonial_sign .ub_testimonial_author_role {
        text-align: center !important;
        margin-top: 5px
    }
    .ub_testimonial_img,
    .ub_testimonial_author {
        text-align: center !important
    }
}

@media(max-width: 320px) {
    .ub_testimonial_content {
        padding: 10px 0
    }
}

.ultimate-blocks-icon-component {
    display: flex;
    justify-content: center;
    align-items: center
}

.ultimate-blocks-icon-component .ultimate-blocks-icon-component-svg-base {
    width: 100%;
    height: 100%
}

@keyframes linearGradientMove {
    to {
        background-position: 6px 0, -6px 100%, 0 -6px, 100% 6px
    }
}

.wp-block-ub-tabbed-content-tab-title-wrap,
.wp-block-ub-tabbed-content-tab-title-vertical-wrap {
    background-color: inherit;
    border-color: lightgrey;
    color: inherit;
}

.wp-block-ub-tabbed-content-tab-title-wrap.active,
.wp-block-ub-tabbed-content-tab-title-vertical-wrap.active,
.wp-block-ub-tabbed-content-accordion-toggle.active {
    background-color: #13294b;
    color: #ffffff;
}

.wp-block-ub-tabbed-content-accordion-toggle.active {
    background-color: #13294b;
}

.wp-block-ub-tabbed-content-tabs-title {
    justify-content: flex-start;
}

.wp-block-ub-tabbed-content-accordion-toggle {
    background-color: transparent;
    color: inherit;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(1) {
    text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(2) {
    text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(3) {
    text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(4) {
    text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(5) {
    text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(6) {
    text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(7) {
    text-align: left;
}



`
